import { Divider } from 'antd';

export const SimpleDivider = () => {
  return <Divider className='my-4' />;
};
